const BaseComponent = require( 'base/base-component' );
const Server = require( 'helper/server' );

class BannerFederationCarousel extends BaseComponent {
  constructor() {
    super( {
      events: {
        'click .prev': 'prevAction',
        'click .next': 'nextAction'
      }
    } );
    this.index = 0;
    this.flag = 0;
    this.options = {
      itemWidth: 380,
      screenItemCount: 3
    };
    this.loadData();
  }

  loadData() {
    /**
     * 专题报道  SpecialReport
     * 集采年会  AnnualMeeting
     * 监管  Supervision
     * 采购人  Purchaser
     * 理论专题  Theory
     * 研修班  StudyClass
     * 操作  Operat
     * @type {*[]}
     */
    const data = [ 'AnnualMeeting', 'Supervision', 'Purchaser', 'Theory', 'StudyClass', 'Operat' ];
    Server.queryCategories( data ).then( res => {
      const data = res || [];
      let html = '';
      $.map( data, ( item, index ) => {
        const { categoryName, imageUrl, isHot } = item;
        const hot = isHot ? `<div class="mark">热门推荐</div>` : '';
        html += `<li data-index="${ index }" class="item">
            ${ hot }
            <img src="${ imageUrl }" alt="${ categoryName }">
        </li>`;
      } );
      this.$el.find( '.categoryitem' ).html( html );
      this.initialization();
    }, ( err ) => {

    } );
  }

  initialization() {
    const $wrap = this.$el.find( 'ul.items' );
    const items = $wrap.children( 'li' );
    const itemLen = items.length;
    const { screenItemCount, options: { itemWidth } } = this;
    if (itemLen <= screenItemCount) {
      return false;
    }
    this.index = - itemLen;
    const prevs = items.clone();
    const nexts = items.clone();
    $wrap.prepend( prevs.addClass( 'prevs' ) ).append( nexts.addClass( 'nexts' ) ).css( 'left', itemWidth * this.index );
  }

  prevAction( e ) {
    const { options: { screenItemCount } } = this;
    if (this.flag) {
      return false;
    }
    this.flag = 1;
    this.index = this.index - screenItemCount;
    this.move( 'prev', this.index );
  }

  nextAction() {
    const { options: { screenItemCount } } = this;
    if (this.flag) {
      return false;
    }
    this.flag = 1;
    this.index = this.index + screenItemCount;
    this.move( 'next', this.index );
  }

  move( type, index = 0 ) {
    const $wrap = this.$el.find( 'ul.items' );
    const items = $wrap.children( 'li' );
    const itemsLen = items.length;
    const { itemWidth, screenItemCount } = this.options;
    $wrap.stop().animate( { left: index * itemWidth }, itemWidth, 'linear', () => {
      const left = Number( $wrap.css( 'left' ).replace( 'px', '' ) );
      if (type === 'prev') {
        const prevCount = Math.abs( this.index );
        const nextCount = itemsLen - prevCount - screenItemCount;
        if (nextCount < screenItemCount) {
          const removeItem = $wrap.children( `li:lt(${ screenItemCount })` );
          removeItem.remove();
          $wrap.append( removeItem );
          this.index = this.index + screenItemCount;
          $wrap.css( 'left', left + ( screenItemCount * itemWidth ) );
        }
      } else if (type === 'next') {
        const prevCount = Math.abs( this.index );
        if (prevCount < screenItemCount) {
          const limit = itemsLen - screenItemCount - 1;
          const removeItem = $wrap.children( `li:gt(${ limit })` );
          removeItem.remove();
          $wrap.prepend( removeItem );
          this.index = this.index - screenItemCount;
          $wrap.css( 'left', left - ( screenItemCount * itemWidth ) );
        }
      }
      this.flag = 0;
    } );
  }
}


module.exports = BannerFederationCarousel;
